import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Modal, Button } from 'react-bootstrap';
import { customStyles } from '../Utility/Utility';

import { AddUpdate } from "../../../ApiMethods/ApiMethods";

const customInputStyle = `
  .form-card input:focus, .form-card textarea:focus, .form-card select:focus {
    border-color: #fdba74 !important;
    box-shadow: 0 0 0 2px rgba(253, 186, 116, 0.2) !important;
    outline: none !important;
  }
  .form-card input, .form-card textarea, .form-card select {
    border: 1px solid #fdba74 !important;
    border-radius: 6px !important;
    font-size: 14px;
    background: #fff;
  }
  .modal-content {
    border-radius: 12px !important;
    border: 1px solid #fdba74 !important;
  }
`;

const VideoPage = () => {
  const [videos, setVideos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [videoName, setVideoName] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchVideos();
  }, []);

const fetchVideos = async () => {
  try {
    const response = await AddUpdate("HomeVideo/GetData_HomeVideo");

   
    const rawData = response?.data?.data;

    if (rawData) {
      const parsed = JSON.parse(rawData); 

      const videoList = Array.isArray(parsed) ? parsed : [parsed]; 
      setVideos(videoList);
    } else {
      console.warn("Empty or malformed data:", response);
    }
  } catch (error) {
    console.error("Error in fetchVideos:", error);
  }
};




  const handleSaveVideo = async (e) => {
    e.preventDefault();
    if (!videoName || !videoUrl) return;

    const payload = {
      Name: videoName,
      URL: videoUrl,
      ...(editId && { HomeVideoID: editId }),
    };

    try {
      const endpoint = editId ? "HomeVideo/UpDate_HomeVideo" : "HomeVideo/Insert_HomeVideo";
      const response = await AddUpdate(endpoint, payload);
      if (response) {
        fetchVideos();
        setVideoName('');
        setVideoUrl('');
        setEditId(null);
        setShowModal(false);
      }
    } catch (error) {
      console.error("Save failed", error);
    }
  };

  const handleEdit = async (id) => {
    try {
      const response = await AddUpdate("HomeVideo/GetSinglaData_HomeVideo", { HomeVideoID: id });
      
      if (response) {
        setVideoName(response.data.data.Name);
        setVideoUrl(response.data.data.URL);
        setEditId(response.data.data.HomeVideoID);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Edit failed", error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this video?")) return;

    try {
      const response = await AddUpdate("HomeVideo/Delete_HomeVideo", { HomeVideoID: id });
      if (response) {
        fetchVideos();
      }
    } catch (error) {
      console.error("Delete failed", error);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setVideoName('');
    setVideoUrl('');
    setEditId(null);
  };

  const filteredVideos = videos.filter(video =>
  video.Name?.toLowerCase().includes(searchQuery.toLowerCase())
);


const columns = [
  {
    name: 'Video Name',
    selector: row => row.Name,
    sortable: true,
  },
  {
    name: 'Video',
    cell: row => (
      <video width="200" controls>
        <source src={row.Url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    ),
  },
  {
    name: 'Action',
    cell: row => (
      <>
        <Button
          variant="info"
          size="sm"
          onClick={() => handleEdit(row.HomeVideoID)}
          className="me-2"
        >
          Edit
        </Button>
        <Button
          variant="danger"
          size="sm"
          onClick={() => handleDelete(row.HomeVideoID)}
        >
          Delete
        </Button>
      </>
    ),
  },
];




  return (
    <>
      <style>{customInputStyle}</style>
      <div className="container-fluid mt-4">
        <div className="row align-items-center mb-3">
          <div className="col-md-6 d-flex align-items-center">
            <h2 className="heading mb-0">Video List</h2>
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            <Button className="btn btn-primary font-w600 mb-2" onClick={() => setShowModal(true)}>
              Add Video
            </Button>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <div className="input-group search-area">
              <input
                type="text"
                className="form-control text-dark"
                placeholder="Search videos..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
              />
              <span className="input-group-text">
                <i className="flaticon-381-search-2"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={filteredVideos}
                    dense
                    highlightOnHover
                    pagination
                    persistTableHead={true}
                    noDataComponent={"There are no videos to display"}
                    customStyles={customStyles}
                    className="mt-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modal */}
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          size="md"
          centered
          backdrop="static"
          keyboard={false}
          className="custom-modal-centered border-0"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h2 className="heading mb-0">{editId ? 'Edit Video' : 'Add Video'}</h2>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto' }}>
            <form className="form-cards" onSubmit={handleSaveVideo}>
              <div className="row">
                <div className="form-group mb-3 col-12">
                  <label>Video Name</label>
                  <input
                    type="text"
                    value={videoName}
                    onChange={e => setVideoName(e.target.value)}
                    placeholder="Enter video name"
                  />
                </div>
                <div className="form-group mb-3 col-12">
                  <label>Video URL</label>
                  <input
                    type="text"
                    value={videoUrl}
                    onChange={e => setVideoUrl(e.target.value)}
                    placeholder="Enter video URL"
                  />
                </div>
              </div>
              <div className="button-group d-flex justify-content-end">
                <Button variant="secondary" className="me-2" onClick={handleCloseModal}>
                  Close
                </Button>
                <Button variant="primary" type="submit">
                  {editId ? 'Update' : 'Save'}
                </Button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default VideoPage;
